import { statuses } from '../state';

export const RESOLVED_STATUSES = [statuses.FAILED, statuses.SUCCESS];

export const hasResolved = (status) => {
  return RESOLVED_STATUSES.includes(status);
};
